(function () {
  'use strict';

  const APP_VERSION = '6.3.0-professional-profile';
  const TOTAL_STEPS = 7;

  const SKIN_OPTIONS = [
    { value: 'dry', title: 'Trockene Haut', text: 'Sie glänzt selten, produziert eher wenig Fett und fühlt sich häufig trocken an.' },
    { value: 'combination', title: 'Mischhaut', text: 'Die T-Zone glänzt, während die Wangen normal oder trockener sein können.' },
    { value: 'oily', title: 'Fettige Haut', text: 'Sie wird im ganzen Gesicht relativ schnell ölig oder glänzend.' },
    { value: 'normal', title: 'Normale Haut', text: 'Sie fühlt sich meistens ausgeglichen an – weder deutlich trocken noch stark ölig.' },
    { value: 'unsure', title: 'Ich bin mir nicht sicher', text: 'Wir bleiben bei möglichst vielseitigen, ausgewogenen Produkten.' }
  ];

  const SKIN_MODIFIER_OPTIONS = [
    { value: 'sensitive', title: 'Empfindliche Haut', text: 'Grundsätzlich empfindlich – auch wenn sie gerade ruhig ist.' },
    { value: 'mature', title: 'Reife Haut', text: 'Reifere Haut – unabhängig davon, ob sie trocken, ölig oder ausgeglichen ist.' }
  ];

  const PRIMARY_OPTIONS = [
    { value: 'clear', concern: 'blemishes', title: 'Clear Skin', text: 'Pickel & entzündliche Unreinheiten' },
    { value: 'pores', concern: 'pores', title: 'Poren & Hautstruktur', text: 'Sichtbare oder verstopfte Poren, Mitesser & unebene Textur' },
    { value: 'tone', concern: 'pigmentation', title: 'Pigmentflecken & Hautton', text: 'Pigmentflecken, dunkle Pickelmale & ungleichmäßiger Hautton' },
    { value: 'calm', concern: 'redness', title: 'Rötungen', text: 'Sichtbare Rötungen & unruhiger Hautton' },
    { value: 'glass', concern: 'glass_skin', title: 'Glass Skin', text: 'Feuchtigkeit, Prallheit & gesunder Glow' },
    { value: 'aging', concern: 'anti_age', title: 'Falten & Festigkeit', text: 'Falten, feine Linien, Elastizitäts- & Festigkeitsverlust' }
  ];

  const SECONDARY_OPTIONS = [
    { value: 'dryness', title: 'Trockenheit & Spannungsgefühl' },
    { value: 'blemishes', title: 'Pickel & Unreinheiten' },
    { value: 'pores', title: 'Poren, Mitesser & unebene Textur' },
    { value: 'pigmentation', title: 'Pigmentflecken & dunkle Pickelmale' },
    { value: 'redness', title: 'Sichtbare Rötungen' },
    { value: 'dullness', title: 'Fahler Teint & fehlender Glow' },
    { value: 'lines', title: 'Falten, feine Linien & Festigkeitsverlust' }
  ];

  const BARRIER_OPTIONS = [
    { value: 'stable', title: 'Ruhig & stabil', text: 'Neue Produkte vertrage ich meistens gut.' },
    { value: 'sometimes', title: 'Manchmal empfindlich', text: 'Gelegentlich Rötung, Trockenheit oder Spannungsgefühl.' },
    { value: 'reactive', title: 'Oft gereizt', text: 'Meine Haut reagiert schnell oder Produkte brennen manchmal.' },
    { value: 'compromised', title: 'Gerade aus dem Gleichgewicht', text: 'Schuppigkeit, Brennen oder starke Trockenheit.' }
  ];

  const EXPERIENCE_OPTIONS = [
    { value: 'beginner', title: 'Ich starte gerade erst', text: 'Meine Pflege ist bisher eher einfach.' },
    { value: 'intermediate', title: 'Ich kenne die Basics', text: 'Niacinamid, Vitamin C oder milde Säuren kenne ich bereits.' },
    { value: 'advanced', title: 'Ich nutze aktive Pflege sicher', text: 'AHA/BHA, Retinoide oder intensive K-Beauty Treatments sind mir vertraut.' }
  ];

  const ROUTINE_OPTIONS = [
    { value: 'minimal', title: 'Minimal', text: 'Genau die 4 Kernschritte – möglichst einfach und alltagstauglich.' },
    { value: 'smart', title: 'Smart Routine', text: '4 Kernschritte plus nur dann eine Zusatzstufe, wenn sie funktional sinnvoll ist.', recommended: true },
    { value: 'ritual', title: 'K-Beauty Ritual', text: 'Mehr Layering und eine zusätzliche Pflegestufe.' }
  ];

  const MAKEUP_OPTIONS = [
    { value: 'rarely', title: 'Fast nie' },
    { value: 'sometimes', title: 'Manchmal' },
    { value: 'most_days', title: 'An den meisten Tagen' }
  ];

  const BUDGET_OPTIONS = [
    { value: 60, title: 'Bis 60 €' },
    { value: 90, title: '60–90 €' },
    { value: 130, title: '90–130 €' },
    { value: 180, title: '130–180 €' },
    { value: 0, title: 'Kein festes Budget' }
  ];

  const ROLE_LABELS = {
    oil_cleanser: 'Ölreinigung',
    cleanser: 'Reinigung',
    toner: 'Toner',
    essence: 'Essence',
    treatment: 'Treatment',
    moisturizer: 'Feuchtigkeit',
    sunscreen: 'Sonnenschutz'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(value) {
    if (!value || value.amount == null) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: value.currencyCode || 'EUR'
      }).format(Number(value.amount));
    } catch (_) {
      return `${value.amount} ${value.currencyCode || 'EUR'}`;
    }
  }

  function variantNumericId(gid) {
    return String(gid || '').split('/').pop();
  }

  function optionButton(option, selected, attrs) {
    const classes = ['sq-option'];
    if (selected) classes.push('is-selected');
    if (option.recommended) classes.push('is-recommended');
    return `
      <button type="button" class="${classes.join(' ')}" ${attrs || ''}>
        ${option.recommended ? '<span class="sq-option__flag">Empfohlen</span>' : ''}
        <span class="sq-option__title">${escapeHtml(option.title)}</span>
        ${option.text ? `<span class="sq-option__text">${escapeHtml(option.text)}</span>` : ''}
      </button>
    `;
  }

  class SkinConsultationApp {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-sq-stage]');
      this.debugPanel = root.querySelector('[data-sq-debug]');
      this.config = {
        domain: root.dataset.shopDomain,
        token: root.dataset.storefrontToken,
        apiVersion: root.dataset.apiVersion || '2026-07',
        collectionHandle: root.dataset.collectionHandle || '',
        cacheMinutes: Number(root.dataset.cacheMinutes || 15),
        pageSize: Number(root.dataset.pageSize || 50),
        debug: root.dataset.debug === 'true'
      };

      const queryParams = new URLSearchParams(window.location.search);
      this.regressionMode = queryParams.get('quiz_regression') === '1';
      this.stockAuditMode = queryParams.get('stock_audit') === '1';
      this.catalogRefreshPromise = null;
      this.catalog = [];
      this.catalogService = null;
      this.catalogPromise = null;
      this.catalogError = null;
      this.catalogSource = '';
      this.step = 0;
      this.answers = {
        skinType: null,
        skinTypeModifiers: [],
        primaryChoice: null,
        secondaryConcerns: [],
        barrier: null,
        activeExperience: null,
        excludeRetinoids: false,
        excludeAcids: false,
        excludeSpicules: false,
        routineStyle: null,
        makeupFrequency: null,
        budgetTotal: null
      };
      this.result = null;
      this.resultDetails = new Map();

      if (this.debugPanel && !this.config.debug) {
        this.debugPanel.hidden = true;
        this.debugPanel.innerHTML = '';
      }
    }

    init() {
      if (!window.SkinQuizCatalog || !window.SkinQuizEngine) {
        this.renderFatal('Die Quiz-Dateien konnten nicht geladen werden.');
        return;
      }

      if (!this.config.token) {
        this.renderFatal('Der Storefront API Token fehlt in den Einstellungen der Quiz-Sektion.');
        return;
      }

      this.catalogService = new window.SkinQuizCatalog.CatalogService(this.config);
      this.startCatalogLoading();

      if (this.stockAuditMode) {
        this.renderStockAuditLoading();
        this.runStockAuditWhenReady();
      } else if (this.regressionMode) {
        this.renderLiveRegressionLoading();
        this.runLiveRegressionWhenReady();
      } else {
        this.renderIntro();
      }
    }

    startCatalogLoading() {
      this.catalogPromise = this.catalogService.load({
        onProgress: progress => this.handleCatalogProgress(progress)
      }).then(loaded => {
        this.catalog = loaded.products || [];
        this.catalogSource = loaded.source || '';
        if (this.config.debug) this.renderDebug();
        this.catalogRefreshPromise = loaded.refreshPromise.then(products => {
          if (Array.isArray(products) && products.length) {
            this.catalog = products;
            this.catalogSource = 'live-sync';
            if (this.config.debug) this.renderDebug();
          }
          return this.catalog;
        }).catch(() => this.catalog);
        return this.catalog;
      }).catch(error => {
        console.error('[SkinQuiz]', error);
        this.catalogError = error;
        throw error;
      });
    }

    handleCatalogProgress(progress) {
      if (!this.config.debug) return;
      this.lastProgress = progress;
      this.renderDebug();
    }

    resetAnswers() {
      this.answers = {
        skinType: null,
        skinTypeModifiers: [],
        primaryChoice: null,
        secondaryConcerns: [],
        barrier: null,
        activeExperience: null,
        excludeRetinoids: false,
        excludeAcids: false,
        excludeSpicules: false,
        routineStyle: null,
        makeupFrequency: null,
        budgetTotal: null
      };
      this.result = null;
      this.resultDetails = new Map();
    }

    renderIntro() {
      this.step = 0;
      this.stage.innerHTML = `
        <div class="sq-intro">
          <div class="sq-intro__copy">
            <div class="sq-eyebrow">${escapeHtml(this.root.dataset.eyebrow || 'K-BEAUTY HAUTANALYSE')}</div>
            <h1 class="sq-title">${escapeHtml(this.root.dataset.heading || 'Finde deine persönliche K-Beauty Routine.')}</h1>
            <p class="sq-lead">${escapeHtml(this.root.dataset.subheading || '7 kurze Schritte. Wir verbinden Hautzustand, Ziele und Verträglichkeit mit passenden Produkten aus unserem Sortiment.')}</p>
            <div class="sq-intro__meta">
              <span>7 Schritte</span>
              <span>ca. 30–40 Sekunden</span>
              <span>individuelle AM/PM Routine</span>
            </div>
            <button type="button" class="sq-primary" data-sq-start>Mit dem Skincare-Quiz starten</button>
          </div>
        </div>
      `;
      this.stage.querySelector('[data-sq-start]').addEventListener('click', () => this.goToStep(1));
    }

    renderHeader(title, subtitle) {
      return `
        <div class="sq-progress" aria-label="Schritt ${this.step} von ${TOTAL_STEPS}">
          <div class="sq-progress__top">
            <button type="button" class="sq-back" data-sq-back aria-label="Zurück">Zurück</button>
            <span>Schritt ${this.step} von ${TOTAL_STEPS}</span>
          </div>
          <div class="sq-progress__track"><span style="width:${(this.step / TOTAL_STEPS) * 100}%"></span></div>
        </div>
        <div class="sq-question-head">
          <h2>${escapeHtml(title)}</h2>
          ${subtitle ? `<p>${escapeHtml(subtitle)}</p>` : ''}
        </div>
      `;
    }

    attachBack() {
      const back = this.stage.querySelector('[data-sq-back]');
      if (back) back.addEventListener('click', () => {
        if (this.step > 1) this.goToStep(this.step - 1);
        else this.renderIntro();
      });
    }

    goToStep(step) {
      this.step = Math.min(TOTAL_STEPS, Math.max(1, step));
      const renderer = this[`renderStep${this.step}`];
      if (renderer) renderer.call(this);
      this.attachBack();
      this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    selectAndNext(field, value) {
      // v6.2: selecting an answer never advances automatically.  The explicit
      // Weiter button is the only navigation action, so accidental taps can be corrected.
      this.answers[field] = value;
    }

    renderStep1() {
      this.stage.innerHTML = `
        ${this.renderHeader('Wie verhält sich deine Haut im Laufe des Tages?', 'Wähle einen Grundtyp. Empfindliche oder reife Haut kannst du zusätzlich markieren.')} 
        <div class="sq-options sq-options--single">
          ${SKIN_OPTIONS.map(option =>
            optionButton(option, this.answers.skinType === option.value, `data-skin-value="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-subtitle" style="margin-top:18px">Trifft zusätzlich etwas zu?</div>
        <div class="sq-options sq-options--compact">
          ${SKIN_MODIFIER_OPTIONS.map(option =>
            optionButton(option, (this.answers.skinTypeModifiers || []).includes(option.value), `data-skin-modifier="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next ${this.answers.skinType ? '' : 'disabled'}>Weiter</button>
        </div>
      `;
      this.stage.querySelectorAll('[data-skin-value]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.skinType = button.dataset.skinValue;
          this.renderStep1(); this.attachBack();
        });
      });
      this.stage.querySelectorAll('[data-skin-modifier]').forEach(button => {
        button.addEventListener('click', () => {
          const value = button.dataset.skinModifier;
          const current = this.answers.skinTypeModifiers || [];
          this.answers.skinTypeModifiers = current.includes(value) ? current.filter(x => x !== value) : current.concat(value);
          this.renderStep1(); this.attachBack();
        });
      });
      const next = this.stage.querySelector('[data-sq-next]');
      if (next) next.addEventListener('click', () => this.goToStep(2));
    }

    renderStep2() {
      this.stage.innerHTML = `
        ${this.renderHeader('Was möchtest du mit deiner Routine am meisten verbessern?', 'Wähle ein Hauptziel. Weitere reale Probleme kannst du im nächsten Schritt ergänzen.')} 
        <div class="sq-options sq-options--goals">
          ${PRIMARY_OPTIONS.map(option =>
            optionButton(option, this.answers.primaryChoice === option.value, `data-primary-value="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next ${this.answers.primaryChoice ? '' : 'disabled'}>Weiter</button>
        </div>
      `;
      this.stage.querySelectorAll('[data-primary-value]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.primaryChoice = button.dataset.primaryValue;
          this.answers.secondaryConcerns = this.getValidSecondarySelections(this.answers.secondaryConcerns);
          this.renderStep2(); this.attachBack();
        });
      });
      const next = this.stage.querySelector('[data-sq-next]');
      if (next) next.addEventListener('click', () => this.goToStep(3));
    }

    primaryOption() {
      return PRIMARY_OPTIONS.find(option => option.value === this.answers.primaryChoice) || PRIMARY_OPTIONS[0];
    }

    secondaryHiddenConcern() {
      const map = {
        clear: 'blemishes',
        pores: 'pores',
        tone: 'pigmentation',
        calm: 'redness',
        glass: 'dullness',
        aging: 'lines'
      };
      return map[this.answers.primaryChoice] || null;
    }

    secondaryOptions() {
      const hidden = this.secondaryHiddenConcern();
      const modifiers = new Set(this.answers.skinTypeModifiers || []);
      const order = [];
      if (modifiers.has('mature') && hidden !== 'lines') order.push('lines');
      if (modifiers.has('sensitive') && hidden !== 'redness') order.push('redness');
      SECONDARY_OPTIONS.forEach(option => { if (!order.includes(option.value)) order.push(option.value); });
      return order.map(value => SECONDARY_OPTIONS.find(option => option.value === value))
        .filter(option => option && option.value !== hidden)
        .slice(0, 6);
    }

    getValidSecondarySelections(values) {
      const allowed = new Set(this.secondaryOptions().map(option => option.value));
      return (values || []).filter(value => allowed.has(value)).slice(0, 2);
    }

    renderStep3() {
      this.answers.secondaryConcerns = this.getValidSecondarySelections(this.answers.secondaryConcerns);
      const options = this.secondaryOptions();
      this.stage.innerHTML = `
        ${this.renderHeader('Was beschäftigt deine Haut außerdem?', 'Wähle bis zu zwei weitere Punkte.')}
        <div class="sq-selection-count"><span data-sq-count>${this.answers.secondaryConcerns.length}</span>/2 ausgewählt</div>
        <div class="sq-options sq-options--compact">
          ${options.map(option =>
            optionButton(option, this.answers.secondaryConcerns.includes(option.value), `data-value="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next>Weiter</button>
        </div>
      `;

      const update = () => {
        this.stage.querySelector('[data-sq-count]').textContent = this.answers.secondaryConcerns.length;
        this.stage.querySelectorAll('.sq-option[data-value]').forEach(button => {
          button.classList.toggle('is-selected', this.answers.secondaryConcerns.includes(button.dataset.value));
        });
      };

      this.stage.querySelectorAll('.sq-option[data-value]').forEach(button => {
        button.addEventListener('click', () => {
          const value = button.dataset.value;
          const selected = this.answers.secondaryConcerns;
          if (selected.includes(value)) {
            this.answers.secondaryConcerns = selected.filter(item => item !== value);
          } else if (selected.length < 2) {
            this.answers.secondaryConcerns = selected.concat(value);
          }
          update();
        });
      });

      this.stage.querySelector('[data-sq-next]').addEventListener('click', () => this.goToStep(4));
    }

    renderStep4() {
      this.stage.innerHTML = `
        ${this.renderHeader('Wie fühlt sich deine Haut aktuell an?', 'Der aktuelle Zustand ist getrennt von deinem grundsätzlichen Hauttyp.')} 
        <div class="sq-options sq-options--single">
          ${BARRIER_OPTIONS.map(option =>
            optionButton(option, this.answers.barrier === option.value, `data-barrier-value="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next ${this.answers.barrier ? '' : 'disabled'}>Weiter</button>
        </div>
      `;
      this.stage.querySelectorAll('[data-barrier-value]').forEach(button => {
        button.addEventListener('click', () => { this.answers.barrier = button.dataset.barrierValue; this.renderStep4(); this.attachBack(); });
      });
      const next = this.stage.querySelector('[data-sq-next]');
      if (next) next.addEventListener('click', () => this.goToStep(5));
    }

    renderStep5() {
      const exclusions = [
        { field: 'excludeRetinoids', label: 'Retinoide vermeiden' },
        { field: 'excludeAcids', label: 'AHA/BHA/PHA-Peelings vermeiden' },
        { field: 'excludeSpicules', label: 'Reedle / Spicule vermeiden' }
      ];

      this.stage.innerHTML = `
        ${this.renderHeader('Wie erfahren bist du mit Wirkstoffen?', 'Wähle dein Erfahrungsniveau und markiere optional, was wir ausschließen sollen.')}
        <div class="sq-split-question">
          <div>
            <div class="sq-subtitle">Erfahrung</div>
            <div class="sq-options sq-options--three">
              ${EXPERIENCE_OPTIONS.map(option =>
                optionButton(option, this.answers.activeExperience === option.value, `data-experience="${option.value}"`)
              ).join('')}
            </div>
          </div>
          <div>
            <div class="sq-subtitle">Optional vermeiden</div>
            <div class="sq-chips">
              ${exclusions.map(item => `
                <button type="button" class="sq-chip ${this.answers[item.field] ? 'is-selected' : ''}" data-exclusion="${item.field}">
                  ${escapeHtml(item.label)}
                </button>
              `).join('')}
            </div>
          </div>
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next ${this.answers.activeExperience ? '' : 'disabled'}>Weiter</button>
        </div>
      `;

      this.stage.querySelectorAll('[data-experience]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.activeExperience = button.dataset.experience;
          this.renderStep5();
          this.attachBack();
        });
      });
      this.stage.querySelectorAll('[data-exclusion]').forEach(button => {
        button.addEventListener('click', () => {
          const field = button.dataset.exclusion;
          this.answers[field] = !this.answers[field];
          button.classList.toggle('is-selected', this.answers[field]);
        });
      });
      const next = this.stage.querySelector('[data-sq-next]');
      if (next) next.addEventListener('click', () => this.goToStep(6));
    }

    renderStep6() {
      this.stage.innerHTML = `
        ${this.renderHeader('Wie soll deine Routine aussehen?', 'Zwei kurze Angaben helfen uns, die Anzahl und Reihenfolge der Schritte festzulegen.')}
        <div class="sq-split-question">
          <div>
            <div class="sq-subtitle">Routine</div>
            <div class="sq-options sq-options--three">
              ${ROUTINE_OPTIONS.map(option =>
                optionButton(option, this.answers.routineStyle === option.value, `data-routine="${option.value}"`)
              ).join('')}
            </div>
          </div>
          <div>
            <div class="sq-subtitle">Make-up oder langanhaltender Sonnenschutz</div>
            <div class="sq-options sq-options--three sq-options--mini">
              ${MAKEUP_OPTIONS.map(option =>
                optionButton(option, this.answers.makeupFrequency === option.value, `data-makeup="${option.value}"`)
              ).join('')}
            </div>
          </div>
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-next ${this.answers.routineStyle && this.answers.makeupFrequency ? '' : 'disabled'}>Weiter</button>
        </div>
      `;

      this.stage.querySelectorAll('[data-routine]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.routineStyle = button.dataset.routine;
          this.renderStep6();
          this.attachBack();
        });
      });
      this.stage.querySelectorAll('[data-makeup]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.makeupFrequency = button.dataset.makeup;
          this.renderStep6();
          this.attachBack();
        });
      });
      const next = this.stage.querySelector('[data-sq-next]');
      if (next) next.addEventListener('click', () => this.goToStep(7));
    }

    renderStep7() {
      this.stage.innerHTML = `
        ${this.renderHeader('Welches Budget möchtest du für deine komplette Routine einplanen?', 'Wir behandeln das Budget als Leitplanke – die Hautverträglichkeit bleibt wichtiger.')}
        <div class="sq-options sq-options--budget">
          ${BUDGET_OPTIONS.map(option =>
            optionButton(option, this.answers.budgetTotal === option.value, `data-budget="${option.value}"`)
          ).join('')}
        </div>
        <div class="sq-actions sq-actions--right">
          <button type="button" class="sq-primary" data-sq-result ${this.answers.budgetTotal !== null ? '' : 'disabled'}>Routine erstellen</button>
        </div>
      `;
      this.stage.querySelectorAll('[data-budget]').forEach(button => {
        button.addEventListener('click', () => {
          this.answers.budgetTotal = Number(button.dataset.budget);
          this.renderStep7();
          this.attachBack();
        });
      });
      const result = this.stage.querySelector('[data-sq-result]');
      if (result) result.addEventListener('click', () => this.createResult());
    }

    buildProfile() {
      const primary = this.primaryOption();
      const barrierMap = {
        stable: { sensitivity: 0, barrierCompromised: false },
        sometimes: { sensitivity: 2, barrierCompromised: false },
        reactive: { sensitivity: 3, barrierCompromised: false },
        compromised: { sensitivity: 4, barrierCompromised: true }
      };
      const barrier = barrierMap[this.answers.barrier] || barrierMap.stable;
      const secondaries = this.answers.secondaryConcerns.slice();

      return {
        skinType: this.answers.skinType,
        skinTypeModifiers: (this.answers.skinTypeModifiers || []).slice(),
        primaryChoice: this.answers.primaryChoice,
        primaryConcern: primary.concern,
        secondaryConcerns: secondaries.slice(0, 2),
        sensitivity: barrier.sensitivity,
        barrierState: this.answers.barrier,
        barrierCompromised: barrier.barrierCompromised,
        activeExperience: this.answers.activeExperience,
        excludeRetinoids: this.answers.excludeRetinoids,
        excludeAcids: this.answers.excludeAcids,
        excludeSpicules: this.answers.excludeSpicules,
        routineStyle: this.answers.routineStyle,
        makeupFrequency: this.answers.makeupFrequency,
        maxRoutineProducts: this.answers.routineStyle === 'ritual' ? 6 : (this.answers.routineStyle === 'smart' ? 5 : 4),
        budgetTotal: this.answers.budgetTotal || null
      };
    }

    async ensureCatalog() {
      // The initial load can resolve from cache while a Storefront refresh is
      // still running. Never rank products against that potentially stale cache.
      if (!this.catalogPromise) this.startCatalogLoading();
      await this.catalogPromise;
      if (this.catalogRefreshPromise) await this.catalogRefreshPromise;
      return this.catalog;
    }

    renderResultLoading() {
      this.stage.innerHTML = `
        <div class="sq-result-loading" role="status" aria-live="polite">
          <div class="sq-loader"></div>
          <div class="sq-eyebrow">DEINE ROUTINE WIRD ERSTELLT</div>
          <h2>Wir gleichen deine Antworten mit unserem aktuellen Sortiment ab.</h2>
          <p>Verfügbarkeit und Preise werden vor dem Ergebnis noch einmal geprüft.</p>
        </div>
      `;
    }

    async createResult() {
      this.renderResultLoading();
      try {
        const catalog = await this.ensureCatalog();
        if (!catalog || !catalog.length) throw new Error('Der Produktkatalog ist nicht verfügbar.');

        const profile = this.buildProfile();
        const routine = window.SkinQuizEngine.recommendRoutine(catalog, profile);
        if (routine.error || !routine.productIds || !routine.productIds.length) {
          throw new Error(routine.error || 'Keine passende Routine gefunden.');
        }

        const details = await this.catalogService.getFreshDetails(routine.productIds);
        this.result = routine;
        this.resultDetails = new Map(details.map(detail => [detail.id, detail]));
        this.renderResult();
      } catch (error) {
        console.error('[SkinQuiz result]', error);
        this.renderResultError(error);
      }
    }

    profileLabels() {
      const skin = SKIN_OPTIONS.find(item => item.value === this.answers.skinType);
      const primary = this.primaryOption();
      const style = ROUTINE_OPTIONS.find(item => item.value === this.answers.routineStyle);
      return [skin && skin.title, primary && primary.title, style && style.title].filter(Boolean);
    }

    resultIntroText() {
      const primary = this.answers.primaryChoice;
      const barrier = this.answers.barrier;
      if (barrier === 'compromised') {
        return 'Deine Routine priorisiert Beruhigung und Barrierepflege. Intensive Wirkstoffe treten bewusst in den Hintergrund, bis sich deine Haut wieder stabil anfühlt.';
      }
      const map = {
        clear: 'Deine Routine konzentriert sich auf klare Poren und ein ausgeglichenes Hautbild, ohne die Basis-Pflege zu vernachlässigen.',
        pores: 'Deine Routine arbeitet gezielt an sichtbaren Poren und Hautstruktur und hält gleichzeitig die Feuchtigkeitsbalance im Blick.',
        tone: 'Deine Routine kombiniert einen gezielten Ansatz für einen gleichmäßigeren Hautton mit konsequentem täglichen Sonnenschutz.',
        calm: 'Deine Routine setzt auf hautberuhigende, möglichst reizarm kombinierte Schritte und eine stabile Feuchtigkeitsbarriere.',
        glass: 'Deine Routine priorisiert Feuchtigkeit, Barriereunterstützung und einen gesunden, prallen Glow.',
        aging: 'Deine Routine verbindet Slow-Aging Wirkstoffe mit Feuchtigkeit und täglichem UV-Schutz.'
      };
      return map[primary] || 'Deine Routine wurde anhand deiner Haut, Ziele und Verträglichkeit zusammengestellt.';
    }

    reasonText(product, detail) {
      if (detail && detail.whySelected) return detail.whySelected;
      const role = product.role;
      const primary = this.primaryOption();
      if (role === 'cleanser') return 'Ausgewählt als passende Basisreinigung für deinen Hauttyp und die Belastung deiner restlichen Routine.';
      if (role === 'oil_cleanser') return 'Als erster Abendschritt ausgewählt, weil du regelmäßig Make-up oder langanhaltenden Sonnenschutz trägst.';
      if (role === 'toner' || role === 'essence') return 'Als zusätzliche K-Beauty Pflegestufe ausgewählt, die deine Kernroutine sinnvoll ergänzt.';
      if (role === 'treatment') return `Der gezielte Wirkstoffschritt für dein Hauptziel „${primary.title}“.`;
      if (role === 'moisturizer') return 'Ausgewählt, um Feuchtigkeit und Barrierebalance passend zu deiner restlichen Routine zu unterstützen.';
      if (role === 'sunscreen') return 'Der tägliche Abschlussschritt zum Schutz der Haut und der Ergebnisse deiner Routine.';
      return 'Passend zu deinem Hautprofil ausgewählt.';
    }

    productView(product) {
      const detail = this.resultDetails.get(product.id) || {};
      const freshVariant = detail.variant || product.variant || null;
      const image = (freshVariant && freshVariant.image) || detail.image || product.image || null;
      return {
        id: product.id,
        role: product.role,
        title: detail.title || product.title,
        vendor: product.vendor || '',
        url: detail.onlineStoreUrl || product.onlineStoreUrl || '#',
        available: detail.availableForSale !== false &&
          freshVariant &&
          freshVariant.availableForSale !== false &&
          (
            freshVariant.quantityAvailable === null ||
            freshVariant.quantityAvailable === undefined ||
            freshVariant.quantityAvailable === '' ||
            Number(freshVariant.quantityAvailable) > 0
          ),
        variant: freshVariant,
        image,
        shortText: detail.benefits || '',
        why: this.reasonText(product, detail),
        schedule: (this.result.schedule && this.result.schedule[product.id]) || '',
        frequency: (this.result.frequency && this.result.frequency[product.id]) || ''
      };
    }

    routineSequence(products, period) {
      const roleOrder = period === 'AM'
        ? ['cleanser', 'toner', 'essence', 'treatment', 'moisturizer', 'sunscreen']
        : ['oil_cleanser', 'cleanser', 'toner', 'essence', 'treatment', 'moisturizer'];
      const byRole = new Map(products.map(product => [product.role, product]));
      return roleOrder.map(role => byRole.get(role)).filter(Boolean);
    }

    renderSequence(title, products) {
      return `
        <div class="sq-sequence">
          <h3>${escapeHtml(title)}</h3>
          <ol>
            ${products.map(product => {
              let usageNote = '';
              if (product.role === 'treatment') {
                if (product.frequency === 'once_daily' && product.schedule === 'AM/PM') usageNote = '1× täglich – morgens oder abends';
                else if (product.frequency === '2_3x_week') usageNote = '2–3× pro Woche';
                else if (product.frequency === 'start_2_3x_week') usageNote = 'Zum Einstieg 2–3× pro Woche';
              }
              return `<li><span>${escapeHtml(ROLE_LABELS[product.role] || product.role)}</span><strong>${escapeHtml(product.title)}</strong>${usageNote ? `<small class="sq-sequence__usage">${escapeHtml(usageNote)}</small>` : ''}</li>`;
            }).join('')}
          </ol>
        </div>
      `;
    }

    renderProductCard(view) {
      const price = view.variant ? money(view.variant.price) : '';
      const compare = view.variant && view.variant.compareAtPrice ? money(view.variant.compareAtPrice) : '';
      return `
        <article class="sq-product ${view.available ? '' : 'is-unavailable'}">
          <a class="sq-product__image" href="${escapeHtml(view.url)}" target="_blank" rel="noopener">
            ${view.image && view.image.url
              ? `<img src="${escapeHtml(view.image.url)}" alt="${escapeHtml(view.image.altText || view.title)}" loading="lazy">`
              : '<div class="sq-product__placeholder"></div>'}
          </a>
          <div class="sq-product__body">
            <div class="sq-product__role">${escapeHtml(ROLE_LABELS[view.role] || view.role)}</div>
            ${view.vendor ? `<div class="sq-product__vendor">${escapeHtml(view.vendor)}</div>` : ''}
            <h3><a href="${escapeHtml(view.url)}" target="_blank" rel="noopener">${escapeHtml(view.title)}</a></h3>
            <div class="sq-product__price">
              ${price ? `<strong>${escapeHtml(price)}</strong>` : ''}
              ${compare ? `<s>${escapeHtml(compare)}</s>` : ''}
            </div>
            ${view.shortText ? `<p class="sq-product__why-title"><strong>Das Wichtigste auf einen Blick</strong></p><p class="sq-product__why">${escapeHtml(view.shortText)}</p>` : ''}
            ${view.available ? `<a class="sq-product__link" href="${escapeHtml(view.url)}" target="_blank" rel="noopener">Produkt ansehen</a>` : '<span class="sq-product__soldout">Aktuell nicht verfügbar</span>'}
          </div>
        </article>
      `;
    }

    renderResult() {
      const views = this.result.products.map(product => this.productView(product));
      const availableViews = views.filter(view => view.available && view.variant && view.variant.id);
      const total = availableViews.reduce((sum, view) => sum + Number(view.variant.price && view.variant.price.amount || 0), 0);
      const currency = availableViews[0] && availableViews[0].variant && availableViews[0].variant.price
        ? availableViews[0].variant.price.currencyCode
        : 'EUR';
      const totalText = total ? new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency
      }).format(total) : '';

      const am = this.routineSequence(
        this.result.morning.map(product => this.productView(product)),
        'AM'
      );
      const pm = this.routineSequence(
        this.result.evening.map(product => this.productView(product)),
        'PM'
      );

      this.stage.innerHTML = `
        <div class="sq-result">
          <div class="sq-result__hero">
            <div class="sq-eyebrow">DEIN HAUTPROFIL</div>
            <div class="sq-profile-tags">${this.profileLabels().map(label => `<span>${escapeHtml(label)}</span>`).join('')}</div>
            <h1>Deine persönliche Routine</h1>
            <p>${escapeHtml(this.resultIntroText())}</p>
          </div>

          <div class="sq-sequences">
            ${this.renderSequence('Morgen', am)}
            ${this.renderSequence('Abend', pm)}
          </div>

          <div class="sq-result__toolbar">
            <div>
              <span>Aktuelle Routine</span>
              ${totalText ? `<strong>${escapeHtml(totalText)}</strong>` : ''}
            </div>
            <button type="button" class="sq-primary" data-sq-add-all ${availableViews.length ? '' : 'disabled'}>
              Gesamte Routine in den Warenkorb
            </button>
          </div>

          <div class="sq-products">
            ${views.map(view => this.renderProductCard(view)).join('')}
          </div>

          <div class="sq-result__footer">
            <p>Hinweis: Bei Schwangerschaft, Stillzeit, Hauterkrankungen oder laufender dermatologischer Behandlung sollten aktive Wirkstoffe zusätzlich fachlich abgeklärt werden.</p>
            <button type="button" class="sq-secondary" data-sq-restart>Quiz neu starten</button>
          </div>
        </div>
      `;

      const addAll = this.stage.querySelector('[data-sq-add-all]');
      if (addAll) addAll.addEventListener('click', () => this.addAllToCart(availableViews, addAll));
      this.stage.querySelector('[data-sq-restart]').addEventListener('click', () => {
        this.resetAnswers();
        this.renderIntro();
        this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      if (this.config.debug) this.renderDebug();
      this.stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }



    async addAllToCart(views, button) {
      const items = views
        .filter(view => view && view.available !== false)
        .filter(view => {
          const q = view && view.variant ? view.variant.quantityAvailable : null;
          return q === null || q === undefined || q === '' || Number(q) > 0;
        })
        .map(view => ({
          id: Number(variantNumericId(view.variant.id)),
          quantity: 1
        }))
        .filter(item => Number.isFinite(item.id));

      if (!items.length) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const original = button.textContent;

      button.disabled = true;
      button.textContent = 'Wird hinzugefügt…';

      const setStatus = message => {
        let status = button.parentElement && button.parentElement.querySelector('[data-sq-cart-status]');
        if (!status && button.parentElement) {
          status = document.createElement('div');
          status.setAttribute('data-sq-cart-status', '');
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          status.style.marginTop = '8px';
          status.style.fontSize = '0.9em';
          button.parentElement.appendChild(status);
        }
        if (status) status.textContent = message;
      };

      const syncCartFromFreshPage = async () => {
        // This mirrors the already-working ATC implementation used elsewhere
        // in this exact Shopify theme: fetch a freshly server-rendered copy of
        // the current page after the cart cookie has changed, then copy its
        // cart bubble and drawer markup into the current document.
        const response = await fetch(window.location.href, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'text/html' }
        });

        if (!response.ok) {
          throw new Error(`Cart UI refresh HTTP ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const headerCartSelectors = [
          '#cart-icon-bubble',
          '.cart-count-bubble',
          '.header__icon--cart',
          '.site-header__cart',
          '[data-cart-icon]',
          '.cart-link',
          'a[href="/cart"]'
        ];

        headerCartSelectors.forEach(selector => {
          const fresh = doc.querySelector(selector);
          const current = document.querySelector(selector);
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            current.className = fresh.className;
          }
        });

        const drawerSelectors = [
          'cart-drawer',
          '#CartDrawer',
          '.cart-drawer',
          '#mini-cart',
          '.mini-cart',
          '.drawer__inner',
          '#cart-dropdown',
          '#shopify-section-cart-drawer'
        ];

        drawerSelectors.forEach(selector => {
          const fresh = doc.querySelector(selector);
          const current = document.querySelector(selector);
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
          }
        });
      };

      const getCart = async () => {
        const response = await fetch(root + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error(`Cart state HTTP ${response.status}`);
        return response.json();
      };

      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        let added = null;
        try {
          added = await response.json();
        } catch (error) {
          added = null;
        }

        if (!response.ok) {
          const message = added && (added.description || added.message)
            ? (added.description || added.message)
            : `Cart HTTP ${response.status}`;
          throw new Error(message);
        }

        // First synchronize the actual theme UI with the same method that is
        // already proven to work on the store.
        await syncCartFromFreshPage();

        // Then read Shopify's real cart state and broadcast the same events
        // used by the working reference implementation.
        const cart = await getCart();

        const addedIds = new Set(items.map(item => Number(item.id)));
        const confirmedIds = new Set(
          (Array.isArray(cart.items) ? cart.items : [])
            .filter(item => Number(item.quantity || 0) > 0)
            .map(item => Number(item.variant_id || item.id))
        );

        const allConfirmed = Array.from(addedIds).every(id => confirmedIds.has(id));
        if (!allConfirmed) {
          throw new Error('Shopify hat nicht alle Produkte im Warenkorb bestätigt.');
        }

        const detail = { cart, source: 'skin-quiz', items, added };

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail
        }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: { items }, cart }
        }));

        window.dispatchEvent(new CustomEvent('cart:updated', { detail }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail }));

        button.textContent = 'Routine ist im Warenkorb';
        button.disabled = true;
        setStatus(`Hinzugefügt. ${cart.item_count} Artikel im Warenkorb.`);
      } catch (error) {
        console.error('[SkinQuiz cart]', error);
        button.disabled = false;
        button.textContent = 'Bitte erneut versuchen';
        setStatus('Die Produkte konnten nicht vollständig hinzugefügt werden. Bitte erneut versuchen.');

        window.setTimeout(() => {
          if (!button.disabled) button.textContent = original;
        }, 3000);
      }
    }

    renderResultError(error) {
      this.stage.innerHTML = `
        <div class="sq-error">
          <div class="sq-eyebrow">ROUTINE KONNTE NICHT ERSTELLT WERDEN</div>
          <h2>Bitte versuche es noch einmal.</h2>
          <p>${escapeHtml(error && error.message ? error.message : 'Unbekannter Fehler')}</p>
          <button type="button" class="sq-primary" data-sq-retry>Erneut versuchen</button>
          <button type="button" class="sq-secondary" data-sq-restart>Von vorne beginnen</button>
        </div>
      `;
      this.stage.querySelector('[data-sq-retry]').addEventListener('click', () => this.createResult());
      this.stage.querySelector('[data-sq-restart]').addEventListener('click', () => {
        this.resetAnswers();
        this.renderIntro();
      });
    }

    renderFatal(message) {
      this.stage.innerHTML = `
        <div class="sq-error">
          <h2>Quiz-Konfiguration</h2>
          <p>${escapeHtml(message)}</p>
        </div>
      `;
    }



    stockAuditTargets() {
      return [
        'Torriden Balanceful Cica Toner Pad 60 sheets, 180ml',
        'Sulwhasoo Essential Comfort Balancing Emulsion 125ml',
        'Sulwhasoo Essential Comfort Balancing Water 150ml',
        'Sulwhasoo Essential Comfort Firming Cream 75ml',
        'Dr.Jart+ V7 toning light 50ml'
      ];
    }

    stockAuditKey(value) {
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    renderStockAuditLoading() {
      this.stage.innerHTML = `
        <div class="sq-result-loading" role="status" aria-live="polite">
          <div class="sq-loader"></div>
          <div class="sq-eyebrow">STOCK AUDIT</div>
          <h2>Wir prüfen die bekannten 0-Bestand-Produkte live.</h2>
          <p>Der Test wartet auf den aktuellen Shopify-Katalog und liest danach quantityAvailable direkt über die Storefront API.</p>
        </div>
      `;
    }

    async runStockAuditWhenReady() {
      try {
        await this.ensureCatalog();
        if (this.catalogRefreshPromise) await this.catalogRefreshPromise;

        const targets = this.stockAuditTargets();
        const catalog = Array.isArray(this.catalog) ? this.catalog : [];
        const matched = targets.map(target => {
          const targetKey = this.stockAuditKey(target);
          let product = catalog.find(item => this.stockAuditKey(item.title) === targetKey);
          if (!product) {
            product = catalog.find(item => {
              const key = this.stockAuditKey(item.title);
              return key.includes(targetKey) || targetKey.includes(key);
            });
          }
          return { target, product: product || null };
        });

        const ids = matched.filter(row => row.product).map(row => row.product.id);
        let freshMap = new Map();

        if (ids.length) {
          const fresh = await this.catalogService.getFreshDetails(ids);
          freshMap = new Map((fresh || []).map(item => [item.id, item]));
        }

        const rows = matched.map(row => {
          if (!row.product) {
            return {
              requested: row.target,
              title: 'Nicht im Storefront-Katalog gefunden',
              quantity: '—',
              availableForSale: '—',
              variantAvailable: '—',
              status: 'NICHT IM KATALOG'
            };
          }

          const fresh = freshMap.get(row.product.id) || {};
          const variant = fresh.variant || row.product.variant || {};
          const qRaw = variant.quantityAvailable;
          const q = qRaw === null || qRaw === undefined || qRaw === '' ? null : Number(qRaw);
          const productAvailable = fresh.availableForSale !== undefined
            ? fresh.availableForSale !== false
            : row.product.availableForSale !== false;
          const variantAvailable = variant.availableForSale !== false;
          const excluded = !productAvailable || !variantAvailable || (Number.isFinite(q) && q <= 0);

          return {
            requested: row.target,
            title: fresh.title || row.product.title,
            quantity: Number.isFinite(q) ? q : 'N/A',
            availableForSale: productAvailable ? 'true' : 'false',
            variantAvailable: variantAvailable ? 'true' : 'false',
            status: excluded ? 'EXCLUDED' : 'ELIGIBLE'
          };
        });

        const excludedCount = rows.filter(row => row.status === 'EXCLUDED').length;
        const foundCount = rows.filter(row => row.status !== 'NICHT IM KATALOG').length;

        this.stage.innerHTML = `
          <div class="sq-result">
            <div class="sq-result__hero">
              <div class="sq-eyebrow">STOCK AUDIT</div>
              <h1>${excludedCount}/${foundCount} gefundene Produkte werden ausgeschlossen</h1>
              <p>Catalog: ${catalog.length} Produkte · source: ${escapeHtml(this.catalogSource || 'unknown')}</p>
            </div>

            <div style="overflow:auto;margin-top:28px;">
              <table style="width:100%;border-collapse:collapse;font-size:14px;text-align:left;">
                <thead>
                  <tr>
                    <th style="padding:10px;border-bottom:1px solid var(--sq-border);">Produkt</th>
                    <th style="padding:10px;border-bottom:1px solid var(--sq-border);">quantityAvailable</th>
                    <th style="padding:10px;border-bottom:1px solid var(--sq-border);">Product available</th>
                    <th style="padding:10px;border-bottom:1px solid var(--sq-border);">Variant available</th>
                    <th style="padding:10px;border-bottom:1px solid var(--sq-border);">Quiz</th>
                  </tr>
                </thead>
                <tbody>
                  ${rows.map(row => `
                    <tr>
                      <td style="padding:10px;border-bottom:1px solid var(--sq-border);">
                        <strong>${escapeHtml(row.title)}</strong>
                        ${row.title !== row.requested ? `<div style="font-size:11px;color:var(--sq-muted);margin-top:3px;">Gesucht: ${escapeHtml(row.requested)}</div>` : ''}
                      </td>
                      <td style="padding:10px;border-bottom:1px solid var(--sq-border);">${escapeHtml(row.quantity)}</td>
                      <td style="padding:10px;border-bottom:1px solid var(--sq-border);">${escapeHtml(row.availableForSale)}</td>
                      <td style="padding:10px;border-bottom:1px solid var(--sq-border);">${escapeHtml(row.variantAvailable)}</td>
                      <td style="padding:10px;border-bottom:1px solid var(--sq-border);"><strong>${escapeHtml(row.status)}</strong></td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>

            <div style="margin-top:22px;padding:16px;border:1px solid var(--sq-border);border-radius:var(--sq-radius);background:var(--sq-card);">
              <strong>Erwartetes Ergebnis:</strong>
              <div style="margin-top:6px;color:var(--sq-muted);">
                Bei allen fünf Produkten sollte quantityAvailable = 0 und Quiz = EXCLUDED stehen.
              </div>
            </div>
          </div>
        `;
      } catch (error) {
        console.error('[SkinQuiz stock audit]', error);
        this.stage.innerHTML = `
          <div class="sq-error">
            <div class="sq-eyebrow">STOCK AUDIT</div>
            <h2>Der Stock-Test konnte nicht ausgeführt werden.</h2>
            <p>${escapeHtml(error && error.message ? error.message : 'Unbekannter Fehler')}</p>
          </div>
        `;
      }
    }

    renderLiveRegressionLoading() {
      this.stage.innerHTML = `
        <div class="sq-result-loading" role="status" aria-live="polite">
          <div class="sq-loader"></div>
          <div class="sq-eyebrow">LIVE REGRESSION</div>
          <h2>Wir testen 10 Hautprofile mit dem aktuellen Shopify-Sortiment.</h2>
          <p>Der Test wartet auf den Live-Sync des Produktkatalogs und misst anschließend Überschneidung, Produktkategorien und Concern-Matches.</p>
        </div>
      `;
    }

    liveRegressionProfiles() {
      return [
        {
          name: 'A · Trocken · Dehydration · sensitiv',
          profile: {
            skinType: 'dry',
            primaryConcern: 'dryness',
            secondaryConcerns: ['redness'],
            sensitivity: 3,
            barrierCompromised: false,
            activeExperience: 'beginner',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 90
          }
        },
        {
          name: 'B · Fettig · Unreinheiten · Poren',
          profile: {
            skinType: 'oily',
            primaryConcern: 'blemishes',
            secondaryConcerns: ['pores'],
            sensitivity: 0,
            barrierCompromised: false,
            activeExperience: 'intermediate',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 90
          }
        },
        {
          name: 'C · Mischhaut · Poren · Minimal · 60 €',
          profile: {
            skinType: 'combination',
            primaryConcern: 'pores',
            secondaryConcerns: ['dryness'],
            sensitivity: 1,
            barrierCompromised: false,
            activeExperience: 'beginner',
            routineStyle: 'minimal',
            makeupFrequency: 'rarely',
            budgetTotal: 60
          }
        },
        {
          name: 'D · Normal · Pigmentflecken · Fahler Teint',
          profile: {
            skinType: 'normal',
            primaryConcern: 'pigmentation',
            secondaryConcerns: ['dullness'],
            sensitivity: 0,
            barrierCompromised: false,
            activeExperience: 'intermediate',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 130
          }
        },
        {
          name: 'E · Trocken · Slow Aging · Beginner',
          profile: {
            skinType: 'dry',
            primaryConcern: 'anti_age',
            secondaryConcerns: ['dryness', 'lines'],
            sensitivity: 1,
            barrierCompromised: false,
            activeExperience: 'beginner',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 130
          }
        },
        {
          name: 'F · Normal · Slow Aging · Advanced',
          profile: {
            skinType: 'normal',
            primaryConcern: 'anti_age',
            secondaryConcerns: ['lines', 'firmness'],
            sensitivity: 0,
            barrierCompromised: false,
            activeExperience: 'advanced',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 180
          }
        },
        {
          name: 'G · Mischhaut · Rötungen · reaktiv',
          profile: {
            skinType: 'combination',
            primaryConcern: 'redness',
            secondaryConcerns: ['sensitivity', 'dryness'],
            sensitivity: 4,
            barrierCompromised: false,
            activeExperience: 'beginner',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 90
          }
        },
        {
          name: 'H · Fettig · Pigmentflecken · Ritual',
          profile: {
            skinType: 'oily',
            primaryConcern: 'pigmentation',
            secondaryConcerns: ['blemishes'],
            sensitivity: 1,
            barrierCompromised: false,
            activeExperience: 'intermediate',
            routineStyle: 'ritual',
            makeupFrequency: 'most_days',
            budgetTotal: 130
          }
        },
        {
          name: 'I · Trocken · Pigmentflecken · sensitiv',
          profile: {
            skinType: 'dry',
            primaryConcern: 'pigmentation',
            secondaryConcerns: ['redness'],
            sensitivity: 3,
            barrierCompromised: false,
            activeExperience: 'beginner',
            routineStyle: 'smart',
            makeupFrequency: 'rarely',
            budgetTotal: 90
          }
        },
        {
          name: 'J · Mischhaut · Unreinheiten · Advanced Ritual',
          profile: {
            skinType: 'combination',
            primaryConcern: 'blemishes',
            secondaryConcerns: ['pores'],
            sensitivity: 0,
            barrierCompromised: false,
            activeExperience: 'advanced',
            routineStyle: 'ritual',
            makeupFrequency: 'most_days',
            budgetTotal: 180
          }
        }
      ];
    }

    async runLiveRegressionWhenReady() {
      try {
        await this.ensureCatalog();
        if (this.catalogRefreshPromise) {
          await this.catalogRefreshPromise;
        }
        if (!this.catalog || !this.catalog.length) {
          throw new Error('Kein Produktkatalog verfügbar.');
        }
        this.runLiveRegression();
      } catch (error) {
        console.error('[SkinQuiz live regression]', error);
        this.stage.innerHTML = `
          <div class="sq-error">
            <div class="sq-eyebrow">LIVE REGRESSION</div>
            <h2>Der Test konnte nicht ausgeführt werden.</h2>
            <p>${escapeHtml(error && error.message ? error.message : 'Unbekannter Fehler')}</p>
          </div>
        `;
      }
    }

    overlapPercent(productsA, productsB) {
      const a = new Set((productsA || []).map(product => product.id));
      const b = new Set((productsB || []).map(product => product.id));
      if (!a.size && !b.size) return 100;
      let intersection = 0;
      a.forEach(id => { if (b.has(id)) intersection += 1; });
      return Math.round((intersection / Math.max(a.size, b.size, 1)) * 1000) / 10;
    }

    median(values) {
      const sorted = (values || []).slice().sort((a, b) => a - b);
      if (!sorted.length) return 0;
      const middle = Math.floor(sorted.length / 2);
      return sorted.length % 2
        ? sorted[middle]
        : (sorted[middle - 1] + sorted[middle]) / 2;
    }

    runLiveRegression() {
      const definitions = this.liveRegressionProfiles();
      const catalogById = new Map(this.catalog.map(product => [product.id, product]));

      const results = definitions.map(definition => {
        const routine = window.SkinQuizEngine.recommendRoutine(this.catalog, definition.profile);
        const checks = (routine.products || []).map(selected => {
          const original = catalogById.get(selected.id) || selected;
          const originalSteps = original && original.quiz && Array.isArray(original.quiz.steps)
            ? original.quiz.steps
            : [original.role];
          const concerns = original && original.quiz && Array.isArray(original.quiz.concerns)
            ? original.quiz.concerns
            : (original.concerns || []);
          const strictCategory = original.role === selected.role;
          const allowedStep = originalSteps.includes(selected.role);
          let primaryConcernMatch = null;
          let primaryConcernBasis = null;
          if (selected.role === 'treatment') {
            const pp = selected.professional || original.professional || {};
            const rs = pp.roleSpecific || {};
            const e = pp.strategyEvidence || {};
            const target = String(pp.primaryTarget || '').toLowerCase();
            const archetype = String(rs.archetype || '').toLowerCase();
            const concern = String(definition.profile.primaryConcern || '').toLowerCase();
            const targetMap = {
              blemishes: {targets:['blemishes'], archetypes:['blemish_control'], evidence:'blemish_control'},
              pores: {targets:['pores'], archetypes:['pore_refinement'], evidence:'pore_refinement'},
              pigmentation: {targets:['pigmentation'], archetypes:['pigment_correction'], evidence:'pigment_correction'},
              redness: {targets:['redness'], archetypes:['redness_support'], evidence:'redness_support'},
              anti_age: {targets:['anti_age'], archetypes:['anti_age'], evidence:'anti_age'},
              lines: {targets:['anti_age'], archetypes:['anti_age'], evidence:'anti_age'},
              firmness: {targets:['anti_age'], archetypes:['anti_age'], evidence:'anti_age'},
              slow_aging: {targets:['anti_age'], archetypes:['anti_age'], evidence:'anti_age'},
              glass_skin: {targets:['glass_skin'], archetypes:['hydration','glow'], evidence:'glass_skin'},
              dryness: {targets:['hydration','glass_skin'], archetypes:['hydration'], evidence:'hydration'},
              dehydration: {targets:['hydration','glass_skin'], archetypes:['hydration'], evidence:'hydration'}
            }[concern];
            const evidence = targetMap ? Number(e[targetMap.evidence] || 0) : 0;
            primaryConcernMatch = targetMap
              ? ((targetMap.targets.includes(target) && evidence >= 1.8) || (targetMap.archetypes.includes(archetype) && evidence >= 2.2))
              : Number((e || {})[concern] || 0) >= 1.8;
            primaryConcernBasis = targetMap
              ? `${target || 'none'} / ${archetype || 'none'} / ${evidence.toFixed(2)}`
              : `evidence:${Number((e || {})[concern] || 0).toFixed(2)}`;
            if (routine.primaryGoalDeferred) primaryConcernMatch = true;
          }

          return {
            id: selected.id,
            title: original.title || selected.title || '',
            vendor: original.vendor || selected.vendor || '',
            selectedRole: selected.role,
            originalRole: original.role || '',
            strictCategory,
            allowedStep,
            primaryConcernMatch,
            primaryConcernBasis,
            concerns
          };
        });

        return {
          name: definition.name,
          profile: definition.profile,
          routine,
          checks
        };
      });

      const pairRows = [];
      const overlaps = [];
      for (let i = 0; i < results.length; i += 1) {
        for (let j = i + 1; j < results.length; j += 1) {
          const overlap = this.overlapPercent(results[i].routine.products, results[j].routine.products);
          overlaps.push(overlap);
          pairRows.push({
            a: String.fromCharCode(65 + i),
            b: String.fromCharCode(65 + j),
            overlap
          });
        }
      }

      const totalProducts = results.reduce((sum, result) => sum + result.checks.length, 0);
      const strictCategoryMatches = results.reduce(
        (sum, result) => sum + result.checks.filter(check => check.strictCategory).length,
        0
      );
      const allowedStepMatches = results.reduce(
        (sum, result) => sum + result.checks.filter(check => check.allowedStep).length,
        0
      );

      const treatmentChecks = results
        .flatMap(result => result.checks)
        .filter(check => check.selectedRole === 'treatment');
      const treatmentPrimaryMatches = treatmentChecks.filter(check => check.primaryConcernMatch).length;

      const activeAnchorMatches = results.filter(result =>
        result.routine && result.routine.coreAudit && result.routine.coreAudit.activeAnchorPresent
      ).length;
      const completeCoreMatches = results.filter(result => {
        const audit = result.routine && result.routine.coreAudit;
        return audit &&
          audit.morningHasCleanser && audit.morningHasMoisturizer && audit.morningHasSunscreen &&
          audit.eveningHasCleanser && audit.eveningHasMoisturizer &&
          audit.sharedCleanser && audit.sharedMoisturizer;
      }).length;

      const averageOverlap = overlaps.length
        ? overlaps.reduce((sum, value) => sum + value, 0) / overlaps.length
        : 0;
      const maxOverlap = overlaps.length ? Math.max(...overlaps) : 0;
      const minOverlap = overlaps.length ? Math.min(...overlaps) : 0;
      const medianOverlap = this.median(overlaps);
      const highPairs = pairRows
        .slice()
        .sort((a, b) => b.overlap - a.overlap)
        .slice(0, 10);

      const recurring = new Map();
      results.forEach(result => {
        (result.routine.products || []).forEach(product => {
          const original = catalogById.get(product.id) || product;
          const current = recurring.get(product.id) || {
            id: product.id,
            title: original.title || product.title || '',
            role: original.role || product.role,
            count: 0
          };
          current.count += 1;
          recurring.set(product.id, current);
        });
      });
      const repeatedProducts = Array.from(recurring.values())
        .sort((a, b) => b.count - a.count || a.title.localeCompare(b.title))
        .filter(item => item.count > 1)
        .slice(0, 15);

      const formatPct = value => `${Number(value || 0).toFixed(1)}%`;
      const routineRows = results.map((result, index) => {
        const products = result.checks.map(check => {
          const flags = [];
          if (!check.strictCategory) flags.push(`CATEGORY: ${check.originalRole}→${check.selectedRole}`);
          if (!check.allowedStep) flags.push('STEP MISMATCH');
          if (check.selectedRole === 'treatment' && check.primaryConcernMatch === false) {
            flags.push('PRIMARY CONCERN MISMATCH');
          }
          return `<div class="sq-reg-product">
            <strong>${escapeHtml(check.selectedRole)}</strong>: ${escapeHtml(check.vendor ? `${check.vendor} · ${check.title}` : check.title)}
            ${flags.length ? `<span class="sq-reg-flag">${escapeHtml(flags.join(' | '))}</span>` : ''}
          </div>`;
        }).join('');

        return `
          <tr>
            <td><strong>${String.fromCharCode(65 + index)}</strong><br>${escapeHtml(result.name)}</td>
            <td>${products || '<em>Keine Produkte</em>'}</td>
            <td>${result.routine.error ? `<span class="sq-reg-flag">${escapeHtml(result.routine.error)}</span>` : 'OK'}</td>
          </tr>
        `;
      }).join('');

      const matrixHeader = results.map((_, index) => `<th>${String.fromCharCode(65 + index)}</th>`).join('');
      const matrixRows = results.map((row, i) => {
        const cells = results.map((col, j) => {
          if (i === j) return '<td>100%</td>';
          return `<td>${formatPct(this.overlapPercent(row.routine.products, col.routine.products))}</td>`;
        }).join('');
        return `<tr><th>${String.fromCharCode(65 + i)}</th>${cells}</tr>`;
      }).join('');

      const copyText = [
        `Catalog: ${this.catalog.length} products; source: ${this.catalogSource || 'unknown'}`,
        `Average overlap: ${formatPct(averageOverlap)}`,
        `Median overlap: ${formatPct(medianOverlap)}`,
        `Min overlap: ${formatPct(minOverlap)}`,
        `Max overlap: ${formatPct(maxOverlap)}`,
        `Strict category match: ${strictCategoryMatches}/${totalProducts} (${formatPct(totalProducts ? strictCategoryMatches / totalProducts * 100 : 0)})`,
        `Allowed step match: ${allowedStepMatches}/${totalProducts} (${formatPct(totalProducts ? allowedStepMatches / totalProducts * 100 : 0)})`,
        `Treatment primary concern match: ${treatmentPrimaryMatches}/${treatmentChecks.length} (${formatPct(treatmentChecks.length ? treatmentPrimaryMatches / treatmentChecks.length * 100 : 0)})`,
        `Active anchor present: ${activeAnchorMatches}/${results.length} (${formatPct(results.length ? activeAnchorMatches / results.length * 100 : 0)})`,
        `Complete shared AM/PM core: ${completeCoreMatches}/${results.length} (${formatPct(results.length ? completeCoreMatches / results.length * 100 : 0)})`,
        '',
        ...results.map((result, index) => {
          const products = result.checks.map(check =>
            `${check.selectedRole}=${check.vendor ? `${check.vendor} ` : ''}${check.title}` +
            `${check.strictCategory ? '' : ` [CATEGORY ${check.originalRole}->${check.selectedRole}]`}` +
            `${check.selectedRole === 'treatment' && check.primaryConcernMatch === false ? ` [PRIMARY MISMATCH · ${check.primaryConcernBasis || 'no therapeutic identity'}]` : ''}`
          ).join(' | ');
          return `${String.fromCharCode(65 + index)} ${result.name}: ${products}`;
        }),
        '',
        'Highest overlap pairs:',
        ...highPairs.map(pair => `${pair.a}-${pair.b}: ${formatPct(pair.overlap)}`)
      ].join('\n');

      const runtimeVersions = {
        quiz: APP_VERSION,
        engine: window.SkinQuizEngine?.constants?.ENGINE_VERSION || 'unknown',
        strategy: window.SkinQuizStrategy?.constants?.STRATEGY_VERSION || 'unknown',
        catalog: window.SkinQuizCatalog?.constants ? `cache-${window.SkinQuizCatalog.constants.CACHE_SCHEMA_VERSION}` : 'unknown',
        api: window.SkinQuizCatalog?.constants?.DEFAULT_API_VERSION || 'unknown'
      };
      const versionLine = `Quiz ${runtimeVersions.quiz} · Engine ${runtimeVersions.engine} · Strategy ${runtimeVersions.strategy} · Catalog ${runtimeVersions.catalog} · API ${runtimeVersions.api}`;
      const versionDebug = `<div style="margin:0 0 18px;padding:10px 12px;border:1px solid rgba(0,0,0,.12);border-radius:8px;font:12px/1.5 monospace;word-break:break-word;"><strong>Runtime versions</strong><br>${escapeHtml(versionLine)}</div>`;

      this.stage.innerHTML = `
        <div class="sq-regression">
          <div class="sq-eyebrow">LIVE REGRESSION · ${escapeHtml(APP_VERSION)}</div>
          ${versionDebug}
          <h2>10 Profile gegen den aktuellen Shopify-Katalog</h2>
          <p>Quelle: <strong>${escapeHtml(this.catalogSource || 'unknown')}</strong> · ${this.catalog.length} publizierte Produkte im geladenen Katalog.</p>

          <div class="sq-result-summary">
            <div><span>Ø Überschneidung</span><strong>${formatPct(averageOverlap)}</strong></div>
            <div><span>Median</span><strong>${formatPct(medianOverlap)}</strong></div>
            <div><span>Maximum</span><strong>${formatPct(maxOverlap)}</strong></div>
            <div><span>Kategorie korrekt</span><strong>${formatPct(totalProducts ? strictCategoryMatches / totalProducts * 100 : 0)}</strong></div>
            <div><span>Step erlaubt</span><strong>${formatPct(totalProducts ? allowedStepMatches / totalProducts * 100 : 0)}</strong></div>
            <div><span>Treatment trifft Hauptziel</span><strong>${formatPct(treatmentChecks.length ? treatmentPrimaryMatches / treatmentChecks.length * 100 : 0)}</strong></div>
            <div><span>Aktiver Kern vorhanden</span><strong>${formatPct(results.length ? activeAnchorMatches / results.length * 100 : 0)}</strong></div>
            <div><span>AM/PM Core vollständig</span><strong>${formatPct(results.length ? completeCoreMatches / results.length * 100 : 0)}</strong></div>
          </div>

          <h3>Routinen</h3>
          <div style="overflow:auto">
            <table class="sq-reg-table">
              <thead><tr><th>Profil</th><th>Empfohlene Produkte</th><th>Status</th></tr></thead>
              <tbody>${routineRows}</tbody>
            </table>
          </div>

          <h3>Overlap-Matrix</h3>
          <div style="overflow:auto">
            <table class="sq-reg-table">
              <thead><tr><th></th>${matrixHeader}</tr></thead>
              <tbody>${matrixRows}</tbody>
            </table>
          </div>

          <h3>Höchste Überschneidungen</h3>
          <p>${highPairs.map(pair => `${pair.a}-${pair.b}: ${formatPct(pair.overlap)}`).join(' · ')}</p>

          <h3>Am häufigsten gewählte Produkte</h3>
          <p>${repeatedProducts.length
            ? repeatedProducts.map(item => `${escapeHtml(item.title)} (${item.count}/10)`).join(' · ')
            : 'Kein Produkt wurde mehrfach gewählt.'}</p>

          <button type="button" class="sq-primary" data-sq-copy-regression>Ergebnisse kopieren</button>
          <textarea data-sq-regression-text style="width:100%;min-height:240px;margin-top:16px;font:12px/1.45 monospace;">${escapeHtml(copyText)}</textarea>
        </div>
      `;

      const copyButton = this.stage.querySelector('[data-sq-copy-regression]');
      const textArea = this.stage.querySelector('[data-sq-regression-text]');
      if (copyButton && textArea) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(textArea.value);
            copyButton.textContent = 'Kopiert';
          } catch (error) {
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            copyButton.textContent = 'Kopiert';
          }
        });
      }
    }

    renderDebug() {
      if (!this.debugPanel || !this.config.debug) return;
      const eligible = this.catalog.filter(product => product.eligibility && product.eligibility.eligible);
      const available = eligible.filter(product => product.availableForSale && product.variant && product.variant.availableForSale);
      const progress = this.lastProgress
        ? `${escapeHtml(this.lastProgress.phase || '')}: ${escapeHtml(this.lastProgress.loaded || 0)}`
        : '';
      this.debugPanel.hidden = false;
      const engineVersion = window.SkinQuizEngine?.constants?.ENGINE_VERSION || 'unknown';
      const strategyVersion = window.SkinQuizStrategy?.constants?.STRATEGY_VERSION || 'unknown';
      const catalogVersion = window.SkinQuizCatalog?.constants?.CACHE_SCHEMA_VERSION ?? 'unknown';
      const apiVersion = window.SkinQuizCatalog?.constants?.DEFAULT_API_VERSION || 'unknown';
      this.debugPanel.innerHTML = `
        <strong>Quiz:</strong> ${escapeHtml(APP_VERSION)}<br>
        <strong>Engine:</strong> ${escapeHtml(engineVersion)}<br>
        <strong>Strategy:</strong> ${escapeHtml(strategyVersion)}<br>
        <strong>Catalog schema:</strong> ${escapeHtml(String(catalogVersion))}<br>
        <strong>API:</strong> ${escapeHtml(apiVersion)}<br>
        <strong>Catalog source:</strong> ${escapeHtml(this.catalogSource || 'loading')}<br>
        <strong>Catalog:</strong> ${available.length} available eligible / ${this.catalog.length} published<br>
        ${progress ? `<strong>Progress:</strong> ${progress}` : ''}
      `;
    }
  }

  function boot() {
    document.querySelectorAll('[data-skin-quiz]').forEach(root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new SkinConsultationApp(root).init();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
